import type { BuildingStorey } from 'api/models';

/** Resolves the selected storey against the model's storeys; a stale or unknown selection shows all storeys. */
export const getActiveStorey = (
    storeys: BuildingStorey[] | undefined,
    selectedStoreyGuid: string | null
): BuildingStorey | null =>
    (selectedStoreyGuid && storeys?.find((storey) => storey.storeyGuid === selectedStoreyGuid)) || null;

/** Keeps only items of the given storey; returns all items when no storey is active. */
export const filterByStorey = <T extends { storeyGuid?: string | null }>(
    items: T[],
    storey: BuildingStorey | null
): T[] => (storey ? items.filter((item) => item.storeyGuid === storey.storeyGuid) : items);

export const formatStoreyLabel = (storey: BuildingStorey) =>
    `${storey.name} (${storey.elevation >= 0 ? '+' : ''}${storey.elevation.toFixed(2)} m)`;
